const initState = () => {
  return {};
}

const me = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_ME":
      return {...action.payload};

    default:
      return state;
  }
}

export default me;
